const config = {
  builder_id: '6123c3504db048793f7e48f0',
  auth_domain: 'elliottconservancy.com',
  entity_logos: {
    plan: 'elevationPhotos[0]',
    community: 'logo',
    home: 'photos[0]',
  },
  social_links: {
    facebook: '/images/icon-social-facebook.svg',
    instagram: '/images/icon-social-instagram.svg',
    youtube: '/images/icon-social-youtube.svg',
    pinterest: '/images/icon-social-pinterest.svg',
    twitter: '/images/icon-social-twitter.svg',
    houzz: '/images/icon-social-houzz.svg',
    linkedin: '/images/icon-social-linkedin.svg',
    googleplus: '/images/icon-social-google-plus.svg',
    fallback: '/images/icon-social-baths.svg',
  },
  mapbox: {
    key: 'pk.eyJ1IjoiYnVpbGRlcmRlc2lnbnMiLCJhIjoiY2ttd2ZyOHR6MGVpZDJ2cGEzMXN1eDFwNCJ9.2WyeKPBN_En8RkTpD51MbA',
  },
  filters: {
    all: {
      Area: {
        routeParam: 'communityMarketArea',
      },
      AreaMetro: {
        routeParam: 'communityMarketAreaMetro',
        child: 'AreaSubMetro',
      },
      AreaSubMetro: {
        routeParam: 'communityMarketAreaSubMetro',
        parent: {
          filter: 'AreaMetro',
          match: ({ self, parent }) => self.value.parentMetro === parent.value.name,
        },
      },
    },
  },
  filterOptions: {
    homes: [
      {
        type: 'SingleSelect',
        filter: 'AreaMetro',
        title: 'State',
        placeholder: 'All States',
        routeParam: 'communityMarketAreaMetro',
        ifProducts: { BDWebsiteMetros: true },
        quickSearch: true,
      },
      {
        type: 'SingleSelect',
        filter: 'AreaSubMetro',
        title: 'Area',
        placeholder: 'All Areas',
        routeParam: 'communityMarketAreaSubMetro',
        ifProducts: { BDWebsiteMetros: true },
        onlyFilters: ['AreaMetro'],
        quickSearch: true,
      },
      {
        type: 'SingleSelect',
        filter: 'City',
        title: 'City',
        placeholder: 'All Cities',
        ifProducts: { BDWebsiteMetros: false },
        onlyFilters: ['AreaMetro', 'AreaSubMetro'],
        quickSearch: true,
      },
      {
        type: 'MultiSelect',
        filter: 'Community',
        title: 'Community',
        placeholder: 'All',
      },
      {
        type: 'MultiSelect',
        filter: 'Price',
        title: 'Price Range',
        placeholder: 'All',
        quickSearch: true,
      },
      {
        type: 'MultiSelect',
        filter: 'Beds',
        title: 'Beds',
        placeholder: 'All',
        quickSearch: true,
      },
      {
        type: 'MultiSelect',
        filter: 'Baths',
        title: 'Baths',
        placeholder: 'All',
      },
    ],
    plans: [
      {
        type: 'SingleSelect',
        filter: 'AreaMetro',
        title: 'Area',
        placeholder: 'All Areas',
        routeParam: 'communityMarketAreaMetro',
        ifProducts: { BDWebsiteMetros: true },
        quickSearch: true,
      },
      {
        type: 'SingleSelect',
        filter: 'AreaSubMetro',
        title: 'Area',
        placeholder: 'All Areas',
        routeParam: 'communityMarketAreaSubMetro',
        ifProducts: { BDWebsiteMetros: true },
        quickSearch: true,
      },
      {
        type: 'SingleSelect',
        filter: 'City',
        title: 'City',
        placeholder: 'All Cities',
        routeParam: 'communityMarketArea',
        onlyFilters: ['AreaMetro', 'AreaSubMetro'],
        quickSearch: true,
      },
      {
        type: 'MultiSelect',
        filter: 'Community',
        title: 'Community',
        placeholder: 'All',
      },
      {
        type: 'MultiSelect',
        filter: 'Beds',
        title: 'Beds',
        placeholder: 'All Beds',
        quickSearch: true,
      },
      {
        type: 'MultiSelect',
        filter: 'Baths',
        title: 'Baths',
        placeholder: 'All Baths',
        quickSearch: true,
      },
      {
        type: 'MultiSelect',
        filter: 'Sqft',
        title: 'Square Feet',
        placeholder: 'All Square Feet',
        quickSearch: true,
      },
    ],
    communities: [
      {
        type: 'SingleSelect',
        filter: 'AreaMetro',
        title: 'State',
        placeholder: 'All States',
        routeParam: 'communityMarketAreaMetro',
        ifProducts: { BDWebsiteMetros: true },
        onlyFilters: [],
        quickSearch: true,
      },
      {
        type: 'SingleSelect',
        filter: 'AreaSubMetro',
        title: 'Area',
        placeholder: 'All Areas',
        routeParam: 'communityMarketAreaSubMetro',
        ifProducts: { BDWebsiteMetros: true },
        onlyFilters: ['AreaMetro'],
        quickSearch: true,
      },
      {
        type: 'SingleSelect',
        filter: 'City',
        title: 'City',
        placeholder: 'All Cities',
        ifProducts: { BDWebsiteMetros: false },
        onlyFilters: ['AreaMetro', 'AreaSubMetro'],
        quickSearch: true,
      },
      {
        type: 'MultiSelect',
        filter: 'Price',
        title: 'Price Range',
        placeholder: 'All',
        quickSearch: true,
      },
      // {
      //   type: 'MultiSelect',
      //   filter: 'SchoolDistrict',
      //   title: 'School Districts',
      //   placeholder: 'All Districts',
      // },
    ],
  },
};

export default config;



// WEBPACK FOOTER //
// ./src/configuration.js